/**
 * Translate description: Pagination
 */

import * as React from 'react';

import { useLanguageContext } from "../../context/LanguageContext";

import Box from '@mui/joy/Box';
import Button from '@mui/joy/Button';
import IconButton, { iconButtonClasses } from '@mui/joy/IconButton';
import Typography from '@mui/joy/Typography';

import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import { useListContext } from '../../provider/ListProvider';
import { useMediaQuery } from '@mui/material';
import { Option, Select } from '@mui/joy';

export default function Pagination() {

  const { t } = useLanguageContext();
  const { page, setPage, total_pages, limit, setLimit, cnt } = useListContext();
  const isSmallScreen = useMediaQuery(theme => theme.breakpoints.down("md"));
  

  return (
    <Box
      className="Pagination-laptopUp"
      sx={{
        pt: 2,
        gap: 1,
        [`& .${iconButtonClasses.root}`]: { borderRadius: '50%' },
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
      }}
    >
      <Button
        size="sm"
        variant="outlined"
        color="neutral"
        startDecorator={<KeyboardDoubleArrowLeftIcon />}
        onClick={() => {
          setPage(1)
        }}
        disabled={page === 1}
        sx={{ '--Button-gap': { xs: '0px', md: '0.375rem'} }}
      >{isSmallScreen ? "" : t('First')}</Button>
      <Button
        size="sm"
        variant="outlined"
        color="neutral"
        startDecorator={<KeyboardArrowLeftIcon />}
        onClick={() => {
          setPage(prev => Math.max(prev - 1, 0));
        }}
        disabled={page === 1}
        sx={{ '--Button-gap': { xs: '0px', md: '0.375rem'} }}
      >{isSmallScreen ? "" : t('Previous')}</Button>

      <Box sx={{ flex: 1 }} />
      {/* {['1', '2', '3', '…', '8', '9', '10'].map((page) => (
          <IconButton
            key={page}
            size="sm"
            variant={Number(page) ? 'outlined' : 'plain'}
            color="neutral"
          >
            {page}
          </IconButton>
        ))} */}
      <Typography level="body-sm" mx="auto" flexShrink={0}>
        {t('Page')} {page} {t('of')} {total_pages}
      </Typography>
      <Select value={limit.toString()} onChange={(_,v)=>{setLimit(v); setPage(1)}} size='sm'>
        <Option value="5">5</Option>
        <Option value="10">10</Option>
        <Option value="25">25</Option>
        <Option value="50">50</Option>
        <Option value="100">100</Option>
      </Select>
      <Typography level="body-sm" mx="auto" flexShrink={0}>
         {cnt} {t('item(s)')}
      </Typography>
      <Box sx={{ flex: 1 }} />

      <Button
        size="sm"
        variant="outlined"
        color="neutral"
        sx={{ '--Button-gap': { xs: '0px', md: '0.375rem'} }}
        endDecorator={<KeyboardArrowRightIcon />}
        onClick={() => {
          setPage((prev) => Math.min(prev + 1, total_pages))
        }}
        disabled={page >= total_pages}
      >{isSmallScreen ? "" : t('Next')}</Button>
      <Button
        size="sm"
        variant="outlined"
        color="neutral"
        sx={{ '--Button-gap': { xs: '0px', md: '0.375rem'} }}
        endDecorator={<KeyboardDoubleArrowRightIcon />}
        onClick={() => {
          setPage(() => total_pages)
        }}
        disabled={page >= total_pages}
      >{isSmallScreen ? "" : t('Last')}</Button>
    </Box>
  )
}